<mat-sidenav-container>
  <mat-sidenav
    class="w-[85vw] max-w-sm border-l border-neutral-200 bg-white print:hidden"
    position="end"
    [mode]="isMobile() ? 'over' : 'side'"
    [opened]="false"
    [disableClose]="!isMobile()"
    fixedInViewport
    #sidenav="matSidenav"
  >
    <admin-sidebar [sidenav]="sidenav" (navItemSelected)="isMobile() && sidenav.close()" />
  </mat-sidenav>

  <mat-sidenav-content
    class="flex flex-col lg:h-dvh lg:overflow-hidden print:ml-0! print:h-auto print:overflow-visible"
  >
    <!-- Banner -->
    <!-- <div
      class="relative isolate w-full bg-emerald-600 px-6 py-4 font-medium text-white print:hidden"
    >
      <a
        class="absolute inset-0 z-10"
        href="https://builderkit.dev?utm_source=angular-material.fusetheme.com&utm_medium=banner&utm_campaign=fuse"
        target="_blank"
        ><span></span
      ></a>
      Check out BuilderKit; the next generation of toolkit for building
      beautiful Angular applications. Use promo code
      <span
        class="rounded-lg bg-emerald-300 px-1.5 py-0.5 text-base font-semibold text-emerald-950"
        >FUSE</span
      >
      on checkout for
      <span class="underline underline-offset-2">20%</span> off your
      purchase!
    </div> -->

    <!-- Toolbar -->
     <div class="border-b">
      <div class="flex items-center  px-4 py-3 print:hidden ml-auto mr-auto"
      style="max-width: 1312px;">
        <!-- Wordmark -->
    <a href="https://truckdriversus.com" class="flex items-center shrink-0">
      <img
        src="/images/logo/tdusa-wordmark.png"
        alt="Site wordmark"
        class="h-4 md:h-6 lg:h-10 w-auto object-contain"
      />
    </a>
  
        <!-- <shortcuts /> -->
  
        <!-- Spacer -->
        <div class="flex-auto"></div>
  
        <!-- <div class="flex items-center gap-x-2">
          <language-switcher />
          <scheme-switcher />
          <notifications />
          <mat-divider
            vertical
            class="mx-1 h-5"
          />
          <assistant />
        </div> -->
  
        <!--mobile-->
        <nav class="flex items-center gap-1 block lg:hidden">
          <a
          routerLink="/"
          routerLinkActive="!text-primary font-semibold"
          mat-flat-button
          class="bg-emerald-600"
        >
          Get Matched Now
        </a>
        </nav>

        <!-- Separator -->
        <div class="mx-3 h-5 border-l block: lg:hidden"></div>

        <!-- Mobile menu toggle (menu slides in from the right) -->
        <button
        class="block: lg:hidden"
        aria-label="Toggle main menu"
          matIconButton
          (click)="sidenav.toggle()"
        >
          <mat-icon svgIcon="text-align-end" />
        </button>
  
        <!--desktop-->
        <nav class="flex items-center gap-1 hidden lg:flex">
          <!-- Dropdown Trigger Button -->
          <button mat-button [matMenuTriggerFor]="jobsMenu" class="flex flex-row items-center text-black text-lg">
            <span class="flex flex-row items-center gap-1">
              <span>Jobs</span>
              <mat-icon svgIcon="chevron-down"></mat-icon>
            </span>
            
          </button>
        
          <!-- Angular Material Menu Definition -->
          <mat-menu #jobsMenu="matMenu" class="mt-2 px-2">
            <a
              routerLink="/jobs"
              routerLinkActive="!text-primary font-semibold"
              mat-menu-item
              class="px-3 py-2"
            >
            <span class="text-lg">Search Jobs</span>
            </a>
            <a
              routerLink="/browse-jobs"
              routerLinkActive="!text-primary font-semibold"
              mat-menu-item
              class="px-3 py-2"
            >
            <span class="text-lg">Browse Jobs</span>
            </a>
            <a
              routerLink="/companies"
              routerLinkActive="!text-primary font-semibold"
              mat-menu-item
              class="px-3 py-2"
            >
            <span class="text-lg">Trucking Companies</span>
            </a>
          </mat-menu>
  
          <!-- Dropdown Trigger Button -->
          <button mat-button [matMenuTriggerFor]="newsMenu" class="flex items-center gap-1 text-black text-lg">
            <span class="flex flex-row items-center gap-1">
              <span>News</span>
              <mat-icon svgIcon="chevron-down"></mat-icon>
            </span>
          </button>
        
          <!-- Angular Material Menu Definition -->
          <mat-menu #newsMenu="matMenu" class="mt-2">
            <a
              href="https://truckdriversus.com/blog"
              routerLinkActive="!text-primary font-semibold"
              mat-menu-item
              class="px-3 py-2"
            >
            <span class="text-lg">News in Trucking</span>
            </a>
            <a
              href="https://truckdriversus.com/events"
              routerLinkActive="!text-primary font-semibold"
              mat-menu-item
              class="px-3 py-2"
            >
            <span class="text-lg">Events</span>
            </a>
            <a
              href="https://truckdriversus.com/heroes"
              routerLinkActive="!text-primary font-semibold"
              mat-menu-item
              class="px-3 py-2"
            >
            <span class="text-lg">Haul of Fame</span>
            </a>
          </mat-menu>

          <!-- Dropdown Trigger Button -->
          <button mat-button [matMenuTriggerFor]="resourcesMenu" class="flex items-center gap-1 text-black text-lg">
            <span class="flex flex-row items-center gap-1">
              <span>Resources</span>
              <mat-icon svgIcon="chevron-down"></mat-icon>
            </span>
          </button>
        
          <!-- Angular Material Menu Definition -->
          <mat-menu #resourcesMenu="matMenu" class="mt-2">
            <button
              [matMenuTriggerFor]="carrierResourcesMenu"
              routerLinkActive="!text-primary font-semibold"
              mat-menu-item
              class="px-3 py-2"
            >
              <span class="text-lg">Carrier Resources</span>
              <span class="text-xs">˅</span>
          </button>
          <button
          [matMenuTriggerFor]="driverResourcesMenu"
          routerLinkActive="!text-primary font-semibold"
          mat-menu-item
          class="px-3 py-2"
        >
          <span class="text-lg">Driver Resources</span>
          <span class="text-xs">˅</span>
      </button>
            <a
              href="https://truckdriversus.com/driver-pay"
              routerLinkActive="!text-primary font-semibold"
              mat-menu-item
              class="px-3 py-2"
            >
            <span class="text-lg">Driver Pay Info</span>
            </a>
          </mat-menu>

          <mat-menu #carrierResourcesMenu="matMenu" class="mt-2">
            <a
            href="https://truckdriversus.com/advertise"
            routerLinkActive="!text-primary font-semibold "
            mat-menu-item
            class="px-3 py-2"
          >
          <span class="text-lg">Post a Job</span>
            
          </a>
          </mat-menu>

          <mat-menu #driverResourcesMenu="matMenu" class="mt-2 px-3">
            <a
            href="https://mobileapp.careerdriver.ai/"
            routerLinkActive="!text-primary font-semibold "
            mat-menu-item
            class="px-3 py-2"
          >
          <span class="text-lg">Career Driver AI</span>
          </a>
          <a
            href="https://www.blueparrott.com/"
            routerLinkActive="!text-primary font-semibold "
            mat-menu-item
            class="px-3 py-2"
          >
          <span class="text-lg">Blue Parrott</span>
          </a>
          <a
            href="https://truckdriversus.com/truck-parking-club"
            routerLinkActive="!text-primary font-semibold "
            mat-menu-item
            class="px-3 py-2"
          >
          <span class="text-lg">Truck Parking Club</span>
          </a>
          <a
            href="https://www.womenintrucking.org/"
            routerLinkActive="!text-primary font-semibold "
            mat-menu-item
            class="px-3 py-2"
          >
            <span class="text-lg">Women in Trucking</span>
          </a>
          <a
            href="https://trckrlifeapparel.com/"
            routerLinkActive="!text-primary font-semibold "
            mat-menu-item
            class="px-3 py-2"
          >
          <span class="text-lg">Trckrlife Apparel</span>
          </a>
          </mat-menu>
        
          <!-- Remaining Nav Items -->
          <a
          href="https://truckdriversus.com/contact"
          routerLinkActive="!text-primary font-semibold"
          mat-button
          class="text-black text-lg"
        >
          Contact
        </a>
          <a
            href="https://truckdriversus.com/advertise"
            routerLinkActive="!text-primary font-semibold "
            mat-flat-button
            class="bg-red-500 text-lg"
          >
            Post a Job
          </a>
          <a
            routerLink="/"
            routerLinkActive="!text-primary font-semibold"
            mat-button
            class="text-black text-lg"
          >
            Get Matched
          </a>
        </nav>      
      </div>
     </div>
    

    <!-- Content -->
    <main
      class="flex flex-col grow h-full lg:flex-auto lg:overflow-auto print:overflow-visible"
    >
      <router-outlet />
      <admin-footer></admin-footer>
  </main>

  </mat-sidenav-content>
</mat-sidenav-container>